import { AlertService } from 'src/app/shared/toast/alert.service';

import { Component, OnInit, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import * as moment from 'moment';
import { ManagePracticeService } from 'src/app/manage-practice/manage-practice.service';
import { CustomValidators } from 'src/app/shared/Validators/custom-validators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.css']
})
export class AddComponent implements OnInit {
  providerSiteForm: FormGroup
  providerSite: any
  dateFormat = ""
  error: any
  title: any = "ProviderSite"
  constructor(
    private _ngZone: NgZone,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private managePracticeService: ManagePracticeService,
    private loadingService: CustomLoadingService,
    private alertService:AlertService,
    private router: Router
  ) {
    window["angularComponentRef"] = { component: this, zone: _ngZone };
    this.providerSiteForm = this.formBuilder.group({
      "Id": [0],
      "Description": [''],
      "ProviderSiteStatus": [true],
      "Address1": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "Address2": [''],
      "City": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "State": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "Zipcode": ['', Validators.compose([Validators.minLength(5)])],
      "ContactNumber": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "Fax": [''],
      "ContactNumberExt": ['']
    });
  }
  getBillingOrMailingAddress(addressType) {
    this.loadingService.show();
    this.managePracticeService.getProviderAddress(addressType).subscribe(res => {
      this.providerSite = res;
      if (this.providerSite) {

        this.BindForm(false);
      }


    }, () => { this.loadingService.hide() }, () => {
      this.loadingService.hide();
    })


  }
  BindForm(setId: boolean) {
    if (setId) {
      this.providerSiteForm.controls["Description"].setValue(this.providerSite.Description);

      this.providerSiteForm.controls["ProviderSiteStatus"].setValue(this.providerSite.ProviderSiteStatus);
    }
    this.providerSiteForm.controls["Address1"].setValue(this.providerSite.Address1);
    this.providerSiteForm.controls["Address2"].setValue(this.providerSite.Address2);
    this.providerSiteForm.controls["City"].setValue(this.providerSite.City);
    this.providerSiteForm.controls["State"].setValue(this.providerSite.State);
    this.providerSiteForm.controls["Zipcode"].setValue(this.providerSite.Zipcode);
    this.providerSiteForm.controls["ContactNumber"].setValue(this.providerSite.ContactNumber);
    this.providerSiteForm.controls["Fax"].setValue(this.providerSite.Fax);
    this.providerSiteForm.controls["ContactNumberExt"].setValue(this.providerSite.ContactNumberExt);
    if (setId)
      this.providerSiteForm.controls["Id"].setValue(this.providerSite.Id)
  }
  ngOnInit(): void {
    this.activatedRoute.data.subscribe((data: { providerSite: any }) => {
      this.providerSite = data.providerSite;
      if (this.providerSite) {
        this.BindForm(true);

      }

    });
  }
  setDate(date: any, fieldName: any) {

    this.providerSiteForm.controls[fieldName].setValue(date);


  }
  AddProviderSite(model: any) {
    console.log(model);
    if (this.providerSiteForm.valid) {
      this.loadingService.show();
      this.managePracticeService.addProviderSite(model).subscribe(res => {
        this.alertService.success(this.translateService.instant("RecordSaved"), { keepAfterRouteChange: true });
        this.router.navigate(["/managepractice/locations/providersites"]);

      }, (error) => {

        this.alertService.error(this.translateService.instant("GenericError"), { keepAfterRouteChange: true });
     
        this.loadingService.hide();
      }, () => {
        this.loadingService.hide();
      })
    }
  }

}

